import { UserLabel } from '@app/pcs/models';
import { Action } from '@ngrx/store';

export enum GridLabelActionTypes {
  AddLabelToSelectedDossiers = '[GridLabel] Add Label To Selected Dossiers',
  AddLabelToSelectedDossiersFail = '[GridLabel] Add Label To Selected Dossiers Fail',

  RemoveLabelFromSelectedDossiers = '[GridLabel] Remove Label From Selected Dossiers',
  RemoveLabelFromSelectedDossiersFail = '[GridLabel] Remove Label From Selected Dossiers Fail',

  CreateDossierLabel = '[GridLabel] Create Dossier Label',
  CreateDossierLabelFail = '[GridLabel] Create Dossier Label Fail',

  UpdateLabel = '[GridLabel] Update Label',
  UpdateLabelFail = '[GridLabel] Update Label Fail'
}

export class AddLabelToSelectedDossiers implements Action {
  readonly type = GridLabelActionTypes.AddLabelToSelectedDossiers;

  constructor(public payload: UserLabel) {
  }
}

export class AddLabelToSelectedDossiersFail implements Action {
  readonly type = GridLabelActionTypes.AddLabelToSelectedDossiersFail;

  constructor(public payload: Error) {
  }
}

export class RemoveLabelFromSelectedDossiers implements Action {
  readonly type = GridLabelActionTypes.RemoveLabelFromSelectedDossiers;

  constructor(public payload: UserLabel) {
  }
}

export class RemoveLabelFromSelectedDossiersFail implements Action {
  readonly type = GridLabelActionTypes.RemoveLabelFromSelectedDossiersFail;

  constructor(public payload: Error) {
  }
}

export class CreateDossierLabel implements Action {
  readonly type = GridLabelActionTypes.CreateDossierLabel;

  constructor(public payload: string) {
  }
}

export class CreateDossierLabelFail implements Action {
  readonly type = GridLabelActionTypes.CreateDossierLabelFail;

  constructor(public payload: Error) {
  }
}

export class UpdateLabel implements Action {
  readonly type = GridLabelActionTypes.UpdateLabel;

  constructor(public payload: UserLabel) {
  }
}

export class UpdateLabelFail implements Action {
  readonly type = GridLabelActionTypes.UpdateLabelFail;

  constructor(public payload: Error) {
  }
}
